/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TextMessageTaskCreatePriority = typeof TextMessageTaskCreatePriority[keyof typeof TextMessageTaskCreatePriority];


export const TextMessageTaskCreatePriority = {
  urgent: 'urgent',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
